module.exports = __webpack_public_path__ + "img/960.a397d248.svg";